module.exports = __webpack_public_path__ + "img/aislacion-termica.81efead5.svg";